import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

const useGetClassIds = (props) => {
  const { subjectId, sections } = props;
  const [classIds, setClassIds] = useState([]);

  useEffect(() => {
    const currentSubjectClasses =
      sections &&
      sections.filter((section) => section.masterSubjectId === subjectId);
    setClassIds(currentSubjectClasses.map((subjectClass) => subjectClass.id));
  }, [sections, subjectId]);

  return [classIds];
};

useGetClassIds.propTypes = {
  subjectId: PropTypes.string.isRequired,
  sections: PropTypes.array.isRequired,
};

export default useGetClassIds;
